export const tableCellArrowSx = {
  color: "grey.100",
  "&:before": {
    border: "1px solid grey.500"
  }
};

export const tableCellTooltipSx = {
  color: "grey.900",
  border: "1px solid grey.500",
  backgroundColor: "grey.100",
  width: "200px",
  fontWeight: "normal",
  "& .listItem": {
    color: "grey.600"
  }
};

export const tableCellTooltip2Sx = {
  color: "grey.900",
  border: "1px solid grey.500",
  backgroundColor: "grey.100",
  fontWeight: "normal",
  "& .listItem": {
    color: "grey.600"
  },
  width: "auto",
  maxWidth: "250px"
};
